import { getCookie, setCookie } from './manageCookie';
import { getV1Access } from './authV1';
import AuthStorage from './authStorage';

export function getToken() {
  return getV1Access();
}

export function deleteToken() {
  if (!window) {
    return;
  }

  let maxCallIndex = 10;
  while (getCookie('token') && maxCallIndex > 0) {
    maxCallIndex -= 1;
    const cookieOptions = {
      path: '/',
      expires: -1,
    };
    // Don't set domain for localhost - it won't work
    if (
      !window.location.host.includes('localhost') &&
      !window.location.host.includes('127.0.0.1')
    ) {
      cookieOptions.domain = `.${window.location.host}`;
    }
    setCookie('token', '', cookieOptions);
  }

  // Also remove from localStorage
  AuthStorage.clearLegacyToken();
}
